import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon48 from '../svgIcon48';

/* eslint-disable max-len */

const CustomercareIcon = ({ fill, ...others }) => (
  <SvgIcon48 title="icons / cat / customerservice" fill={fill} {...others}>
    <path d="M11.996 23c-1.101.004-1.992.896-1.996 1.998h0a2 2 0 1 0 4 0h0C13.996 23.893 13.1 23 11.996 23zm6 0c-1.101.004-1.992.896-1.996 1.998h0a2 2 0 1 0 4 0h0C19.996 23.893 19.1 23 17.996 23zm6 0c-1.101.004-1.992.896-1.996 1.998h0a2 2 0 1 0 4 0h0C25.996 23.893 25.1 23 23.996 23h0zM40.371 8H22.07c-2.004 0-3.629 1.637-3.629 3.657v3.756H8.629c-2.001 0-3.625 1.633-3.629 3.65V31.4c0 2.02 1.625 3.657 3.629 3.657h.046l.053 4.798a1.16 1.16 0 0 0 .724 1.062c.432.174.926.069 1.251-.266l5.374-5.581H26.93c2.004 0 3.629-1.637 3.629-3.657v-3.769h1.936l5.657 5.84c.326.335.819.44 1.251.266a1.16 1.16 0 0 0 .724-1.062l.072-5.044h.171c2.004 0 3.629-1.637 3.629-3.657v-12.33C44 9.637 42.375 8 40.371 8zM28.247 25.321V31.4c0 .733-.59 1.327-1.317 1.327H15.59a1.15 1.15 0 0 0-.83.352l-3.754 3.909-.04-3.106c-.007-.636-.521-1.148-1.152-1.148H8.629c-.727 0-1.317-.594-1.317-1.327V19.063c0-.733.59-1.327 1.317-1.327H26.93c.727 0 1.317.594 1.317 1.327v6.258zm13.441-1.327c0 .733-.59 1.327-1.317 1.327h-1.317c-.621.014-1.119.522-1.126 1.148l-.046 3.391-4.057-4.188a1.15 1.15 0 0 0-.823-.352h-2.443v-6.258c0-2.02-1.625-3.657-3.629-3.657h-6.177v-3.75c0-.733.59-1.327 1.317-1.327h18.308c.727 0 1.317.594 1.317 1.327l-.007 12.337z" />
  </SvgIcon48>
);

CustomercareIcon.propTypes = {
  fill: PropTypes.string,
};
CustomercareIcon.defaultProps = {
  fill: '#828282',
};

export default CustomercareIcon;
